import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Chart from './Chart';
import Totals from './Totals';
import {BudgetDataWrapper, ChartAndHighLevelNumbers} from '../../BudgetData.styled';
import HighLevelBudgetNumbers, {highLevelBudgetNumbersQuery} from '../../HighLevelBudgetNumbers';
import ForecastQueryRenderer from '../../../../../../ForecastQueryRenderer';
import InlineLoader from '../../../../../../forecast-app/shared/components/inline-loader/inline_loader';

const BudgetData = ({project, selectValueType, selectedViewType, eyeOptionMap, hasBaseline}) => {
	return (
		<>
			<BudgetDataWrapper>
				<ChartAndHighLevelNumbers>
					<Chart
						project={project}
						selectedViewType={selectedViewType}
						eyeOptionMap={eyeOptionMap}
						hasBaseline={hasBaseline}
					/>
					{project.billable && (
						<ForecastQueryRenderer
							componentName="high_level_numbers_loader"
							query={highLevelBudgetNumbersQuery}
							variables={{
								projectId: `${project.id}`,
							}}
							authorizeAccessRoute={'project-budget'}
							showLoader={true}
							customLoader={() => <InlineLoader />}
							render={relayProps => {
								return <HighLevelBudgetNumbers key={'HighLevelBudgetNumbers'} {...relayProps} />;
							}}
						/>
					)}
				</ChartAndHighLevelNumbers>
				<Totals
					project={project}
					eyeOptionMap={eyeOptionMap}
					selectValueType={selectValueType}
					hasBaseline={hasBaseline}
				/>
			</BudgetDataWrapper>
		</>
	);
};

export default createFragmentContainer(BudgetData, {
	project: graphql`
		fragment BudgetData_project on ProjectType {
			...Chart_project
			...Totals_project
			id
			billable
		}
	`,
});
